import { useState } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon//locked.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import { currencyFormat } from "../../Utils/helper";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";
import EditAttorneyLiensPopup from "../Modals/EditAttorneyLiensPopup";

import SectionActionBar from "./SectionActionBar";
import updateLockSettleAmount from "./common/updateLockSettleAmount";
import AllLockSettle from "./common/AllLockSettle";
import updateLockSettleValue from "./common/updateLockSettleValue";
import ChequeUpload from "./ChequeUpload";
import CopyValueSettlement from "./common/CopyValueSettlement";
import updateRightColumnValue from "./common/updateRightColumnValue";
import SettlementEmptyMessage from "./SettlementEmptyMessage";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import SettlementCurrencyInput from "./common/SettlementCurrencyInput";
import { hasNonZeroSettlementAmount, hasSettlementCheck } from "./common/settlementCheckGuards";

const OpposingCounselingLiensTable = ({
  opposingCounselObj,
  clientProceeds,
  settlementObjProps,
}) => {
  // const [isHovered, setIsHovered] = useState({ id: -1, value: false });
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  const [currentOpposingLien, setCurrentOpposingLien] = useState(null);
  const [errorMsg, _setMsgError] = useState("");
  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);

  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };
  const lockAllLiens = (bType, boolVal) => {
    AllLockSettle("opposing_counsel", bType, boolVal);
    if (bType === "draft1") {
      setOpposingCounselingLiensLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setOpposingCounselingLiensLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: row.checkID ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const handleDraftLockChange = (id, e) => {
    e.stopPropagation();
    const lock = opposingCounselingLiensLocks.find((row) => row.id === id);
    if (hasSettlementCheck(lock)) {
      handleCheckedRowClick(e);
      return;
    }
    updateLockSettleValue(id, "opposing_counsel", "draft1");
    setOpposingCounselingLiensLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row))
    );
  };
  const handleFinalLockChange = (id, e) => {
    e.stopPropagation();
    const lock = opposingCounselingLiensLocks.find((row) => row.id === id);
    if (hasSettlementCheck(lock)) {
      handleCheckedRowClick(e);
      return;
    }
    updateLockSettleValue(id, "opposing_counsel", "final");
    setOpposingCounselingLiensLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row))
    );
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const { updateClientProceedsState } = clientProceeds;
  const {
    opposingCounselingLienFinalAmount,
    opposingCounselingLiens,

    opposingCounselingLiensLocks,
    setOpposingCounselingLiensLocks,
    opposingCounselingLiensLocksValues,
    setOpposingCounselingLiensLocksValues,
    showEditLien,
    handleEditLienClose,
    handleEditLienShow,
    showErrorLeinModal,
    handleLienErrorClose,
    handleLienErrorShow: _handleLienErrorShow,
    updateOpposingCounselingStates,
  } = opposingCounselObj;
  const getInputSum = (className) =>
    [...document.querySelectorAll(`.${className}`)].reduce((acc, input) => {
      const val = input.getAttribute("data-value") || "0";
      const num = parseFloat(val);

      return !isNaN(num) ? acc + num : acc;
    }, 0);
  return (
    <>
      <div className="m-t-5">
        <SectionActionBar sectionName={"Prior Attorney Liens"} />
        <div className="table--no-card rounded-0 border-0 w-100">
          <table className="table table-borderless table-striped table-earning settlement-table">
            <thead>
              <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                <th className="" />
                <th className="td-autosize text-start first-col">Firm Name</th>
                <th className="td-autosize text-center">File Number</th>
                <th className="text-center td-autosize">Type</th>
                <th className="text-end dollar-amount-value td-autosize">Original Lien</th>
                {/* <th className="text-end dollar-amount-value td-autosize">Costs</th> */}
                {/* <th className="text-end dollar-amount-value td-autosize">Total Lien</th> */}
                <th className="" />
                <th
                  className={`height-25 text-end fw-bold td-autosize ${opposingCounselingLiensLocks?.some((lock) => !lock?.isDraftLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  // style={{color:"var(--primary-25) !important"}}
                  onClick={() => {
                    const draftLockCheck = opposingCounselingLiensLocks?.some(
                      (lock) => !lock?.isDraftLocked && !hasSettlementCheck(lock)
                    );
                    if (draftLockCheck) {
                      opposingCounselingLiensLocks?.forEach((lien, index) => {
                        if (!lien?.isDraftLocked && !hasSettlementCheck(lien)) {
                          updateRightColumnValue(
                            lien?.isDraftLocked,
                            lien?.isFinalLocked,
                            setOpposingCounselingLiensLocks,
                            "opposing-draft",
                            lien?.id,
                            opposingCounselingLiensLocksValues,
                            setOpposingCounselingLiensLocksValues,
                            "opposing_counsel",
                            "draft1",
                            opposingCounselingLiens[index]?.amount
                          );
                        }
                      });
                      updateOpposingCounselingStates();
                      updateClientProceedsState();
                    }
                  }}
                >
                  <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                    {opposingCounselingLiensLocks?.some(
                      (lock) => !lock?.isDraftLocked && !hasSettlementCheck(lock)
                    ) && <CopyValueSettlement />}
                    Total Lien
                  </span>
                </th>
                <th
                  className={`s-draft text-end ${opposingCounselingLiensLocks?.some((lock) => lock?.isDraftLocked && !lock?.isFinalLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  style={{ color: "var(--primary-25) !important" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const finalLockCheck = opposingCounselingLiensLocks?.some(
                      (lock) =>
                        lock?.isDraftLocked && !lock?.isFinalLocked && !hasSettlementCheck(lock)
                    );
                    if (finalLockCheck) {
                      opposingCounselingLiensLocks?.forEach((lien) => {
                        if (
                          lien?.isDraftLocked &&
                          !lien?.isFinalLocked &&
                          !hasSettlementCheck(lien)
                        ) {
                          updateRightColumnValue(
                            lien?.isDraftLocked,
                            lien?.isFinalLocked,
                            setOpposingCounselingLiensLocks,
                            "opposing-final",
                            lien?.id,
                            opposingCounselingLiensLocksValues,
                            setOpposingCounselingLiensLocksValues,
                            "opposing_counsel",
                            "final",
                            lien?.isDraftAmount
                          );
                        }
                      });
                      updateClientProceedsState();
                    }
                  }}
                >
                  <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center position-relative">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19 lock-icon"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("draft1", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19 lock-icon"
                        alt="lock-icon"
                        src={draftLocked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("draft1", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span
                      className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                      style={{ paddingRight: "2px" }}
                    >
                      {opposingCounselingLiensLocks?.some(
                        (lock) =>
                          lock?.isDraftLocked && !lock?.isFinalLocked && !hasSettlementCheck(lock)
                      ) && <CopyValueSettlement />}
                      <span className="position-absolute right-0">Draft</span>
                    </span>
                  </div>
                </th>
                <th className="s-final text-end" style={{ color: "var(--primary-25) !important" }}>
                  <div className="d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("final", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19"
                        alt="lock-icon"
                        src={locked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("final", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span style={{ paddingRight: "2px" }}>Final</span>
                  </div>
                </th>
                <th className="s-verify" />
                <th
                  className="td-autosize check-request--btn-settle text-center"
                  style={{ color: "var(--primary-25) !important" }}
                >
                  Check
                </th>
              </tr>
            </thead>
            <tbody id="body-table">
              {opposingCounselingLiens?.length === 0 && (
                <tr id="cost-settle-row" className="add-btn-row cursor-default padding-tr-0">
                  <td className="text=center cursor-pointer" colSpan={12}>
                    <SettlementEmptyMessage
                      name="PRIOR ATTORNEY LIENS"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSettlementPopup(true);
                      }}
                    />
                  </td>
                </tr>
              )}
              {opposingCounselingLiens?.length > 0 &&
                opposingCounselingLiens?.map((lien, index) => (
                  <tr
                    onClick={() => {
                      if (hasSettlementCheck(opposingCounselingLiensLocks[index])) {
                        return;
                      }
                      setCurrentOpposingLien(lien);
                      handleEditLienShow();
                    }}
                    className="cursor-default"
                  >
                    <td className="">{index + 1}</td>
                    <td className="first-col text-start">{lien?.firm_name}</td>
                    <td className="td-autosize text-center">{lien?.file_number}</td>
                    <td className="text-center td-autosize">Prior Attorney</td>
                    <td
                      className="text-end monospace-font td-autosize dollar-amount-value"
                      data-value={lien?.orignal_lien || 0.0}
                    >
                      {currencyFormat(lien?.orignal_lien || 0.0)}
                    </td>
                    {/* <td className="text-end monospace-font td-autosize dollar-amount-value" data-value={ 0.00}>{currencyFormat( 0.00)}</td> */}
                    {/* <td className="text-end monospace-font td-autosize dollar-amount-value" data-value={lien?.final_lien || 0.00}>{currencyFormat(lien?.final_lien || 0.00)}</td> */}
                    <td className="" />
                    <td
                      className={`monospace-font  dollar-amount-value td-autosize text-end ${!opposingCounselingLiensLocks[index].isDraftLocked && !hasSettlementCheck(opposingCounselingLiensLocks[index]) ? "cursor-pointer" : ""}`}
                      data-value={lien?.final_lien}
                    >
                      <span
                        className={`d-flex align-items-center ${!opposingCounselingLiensLocks[index].isDraftLocked && !hasSettlementCheck(opposingCounselingLiensLocks[index]) ? "justify-content-between cursor-pointer" : "justify-content-end"} align-items-center position-relative center-val-div`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hasSettlementCheck(opposingCounselingLiensLocks[index])) {
                            handleCheckedRowClick(e);
                            return;
                          }
                          updateRightColumnValue(
                            opposingCounselingLiensLocks[index].isDraftLocked,
                            opposingCounselingLiensLocks[index].isFinalLocked,
                            setOpposingCounselingLiensLocks,
                            "opposing-draft",
                            lien?.id,
                            opposingCounselingLiensLocks,
                            setOpposingCounselingLiensLocksValues,
                            "opposing_counsel",
                            "draft1",
                            lien?.final_lien
                          );
                          updateOpposingCounselingStates();
                          updateClientProceedsState();
                        }}
                      >
                        {!opposingCounselingLiensLocks[index].isDraftLocked &&
                          !hasSettlementCheck(opposingCounselingLiensLocks[index]) && (
                            <CopyValueSettlement />
                          )}
                        {currencyFormat(lien?.final_lien)}
                      </span>
                    </td>
                    <td
                      className="s-draft text-end"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (hasSettlementCheck(opposingCounselingLiensLocks[index])) {
                          handleCheckedRowClick(e);
                          return;
                        }
                        updateRightColumnValue(
                          opposingCounselingLiensLocks[index].isDraftLocked,
                          opposingCounselingLiensLocks[index].isFinalLocked,
                          setOpposingCounselingLiensLocks,
                          "opposing-final",
                          lien?.id,
                          opposingCounselingLiensLocksValues,
                          setOpposingCounselingLiensLocksValues,
                          "opposing_counsel",
                          "final",
                          opposingCounselingLiensLocks[index].isDraftAmount
                        );
                        updateOpposingCounselingStates();
                        updateClientProceedsState();
                      }}
                    >
                      <div
                        className={
                          "monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                        }
                      >
                        <span>
                          {" "}
                          {!hasSettlementCheck(opposingCounselingLiensLocks[index]) && (
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDraftLockChange(lien?.id, e);
                              }}
                              id="lock-image"
                              className="ic ic-15"
                              src={
                                opposingCounselingLiensLocks[index].isDraftLocked
                                  ? draftLocked
                                  : unlocked
                              }
                              alt="lock-icon"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>

                        <SettlementCurrencyInput
                          id="lock-input"
                          className={`${opposingCounselingLiensLocks[index].isDraftLocked && !opposingCounselingLiensLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font opposing-draft-${lien?.id} text-end opposing-draft dollar-amount-value ${
                            opposingCounselingLiensLocks[index].isDraftLocked
                              ? "locked-input"
                              : "unlock-input"
                          }`}
                          value={lien?.draft1}
                          readOnly={
                            opposingCounselingLiensLocks[index].isDraftLocked ||
                            hasSettlementCheck(opposingCounselingLiensLocks[index])
                          }
                          onClick={(e) => {
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                            e.target.focus(); // Ensure input gets focus
                          }}
                          onLocalChange={({ dataValue }) => {
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) return;
                            setOpposingCounselingLiensLocks((prevStates) =>
                              prevStates.map((row) =>
                                row.id === lien?.id ? { ...row, isDraftAmount: dataValue } : row
                              )
                            );
                            const sum = getInputSum("opposing-draft");
                            setOpposingCounselingLiensLocksValues((prevValues) => [
                              sum,
                              prevValues[1],
                            ]);
                          }}
                          onDebouncedCommit={async ({ submitValue }) => {
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) return;
                            await updateLockSettleAmount(
                              lien?.id,
                              "opposing_counsel",
                              "draft1",
                              submitValue
                            );
                            updateOpposingCounselingStates();
                            updateClientProceedsState();
                          }}
                          onMouseEnter={(e) => {
                            if (
                              opposingCounselingLiensLocks[index].isDraftLocked &&
                              !opposingCounselingLiensLocks[index].isFinalLocked &&
                              !hasSettlementCheck(opposingCounselingLiensLocks[index])
                            ) {
                              const container = e.currentTarget.closest(".center-val-div");
                              const lockImg = container?.querySelector("#lock-image");
                              const copyElement = container?.querySelector(
                                ".copy-centered-draft, .copy-centered-final, .copy-centered"
                              );
                              if (lockImg) {
                                lockImg.style.opacity = 0;
                                lockImg.style.zIndex = 0;
                              }
                              if (copyElement) {
                                copyElement.style.opacity = 1;
                                copyElement.style.zIndex = 1;
                                copyElement.style.cursor = "pointer";
                                copyElement.style.display = "flex";
                              }
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (
                              opposingCounselingLiensLocks[index].isDraftLocked &&
                              !opposingCounselingLiensLocks[index].isFinalLocked &&
                              !hasSettlementCheck(opposingCounselingLiensLocks[index])
                            ) {
                              const container = e.currentTarget.closest(".center-val-div");
                              const lockImg = container?.querySelector("#lock-image");
                              const copyElement = container?.querySelector(
                                ".copy-centered-draft, .copy-centered-final, .copy-centered"
                              );
                              if (lockImg) {
                                lockImg.style.opacity = 1;
                                lockImg.style.zIndex = 1;
                              }
                              if (copyElement) {
                                copyElement.style.opacity = 0;
                                copyElement.style.zIndex = 0;
                                copyElement.style.cursor = "initial";
                                copyElement.style.display = "none";
                              }
                            }
                          }}
                          style={{ zIndex: 2 }}
                        />
                        {opposingCounselingLiensLocks[index].isDraftLocked &&
                          !opposingCounselingLiensLocks[index].isFinalLocked &&
                          !hasSettlementCheck(opposingCounselingLiensLocks[index]) && (
                            <CopyValueSettlement draft={true} />
                          )}
                      </div>
                    </td>
                    <td className="s-final" onClick={(e) => e.stopPropagation()}>
                      <div
                        // onMouseEnter={() => setIsHovered({ id: lien?.id, value: true })}
                        // onMouseLeave={() => setIsHovered({ id: lien?.id, value: false })}
                        className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                      >
                        <span>
                          {!hasSettlementCheck(opposingCounselingLiensLocks[index]) && (
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                handleFinalLockChange(lien?.id, e);
                              }}
                              id="lock-image"
                              className={`ic ic-15 ${opposingCounselingLiensLocks[index].checkID?.check_sent ? "invisible" : ""} `}
                              src={
                                opposingCounselingLiensLocks[index].isFinalLocked
                                  ? opposingCounselingLiensLocks[index].checkID?.check_sent
                                    ? lockedGrey
                                    : locked
                                  : opposingCounselingLiensLocks[index].checkID?.check_sent
                                    ? unlockedGrey
                                    : unlocked
                              }
                              alt="lock-icon"
                              style={{ cursor: "pointer" }}
                              // onMouseEnter={() => setIsHovered({ id: lien?.id, value: false })}
                              // onMouseLeave={() => setIsHovered({ id: lien?.id, value: true })}
                            />
                          )}
                        </span>
                        <SettlementCurrencyInput
                          id="lock-input"
                          className={`${!opposingCounselingLiensLocks[index].checkID && opposingCounselingLiensLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font opposing-final-${lien?.id} text-end opposing-final dollar-amount-value ${
                            opposingCounselingLiensLocks[index].isFinalLocked
                              ? "locked-input"
                              : "unlock-input"
                          }`}
                          value={lien?.final}
                          readOnly={
                            opposingCounselingLiensLocks[index].isFinalLocked ||
                            hasSettlementCheck(opposingCounselingLiensLocks[index])
                          }
                          onClick={async (e) => {
                            e.stopPropagation();
                            e.target.focus(); // Ensure input gets focus
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                          }}
                          onLocalChange={({ dataValue }) => {
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) return;
                            setOpposingCounselingLiensLocks((prevStates) =>
                              prevStates.map((row) =>
                                row.id === lien?.id ? { ...row, isFinalAmount: dataValue } : row
                              )
                            );
                            const sum = getInputSum("opposing-final");
                            setOpposingCounselingLiensLocksValues((prevValues) => [
                              prevValues[0],
                              sum,
                            ]);
                          }}
                          onDebouncedCommit={async ({ submitValue }) => {
                            if (hasSettlementCheck(opposingCounselingLiensLocks[index])) return;
                            await updateLockSettleAmount(
                              lien?.id,
                              "opposing_counsel",
                              "final",
                              submitValue
                            );
                            updateOpposingCounselingStates();
                            updateClientProceedsState();
                          }}
                        />
                        {!opposingCounselingLiensLocks[index].checkID &&
                          opposingCounselingLiensLocks[index].isFinalLocked && (
                            <CopyValueSettlement draft={true} final={true} />
                          )}
                      </div>
                    </td>
                    <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                      <ChequeUpload
                        entity={lien}
                        panel={"opposing_counsel"}
                        pageId={page_id_click_record}
                        documentType="verify"
                        updateStates={updateOpposingCounselingStates}
                        handleNoCheckShow={handleNoCheckShow}
                      />
                    </td>
                    <td className="td-autosize text-center " onClick={(e) => e.stopPropagation()}>
                      <div
                        className={`${opposingCounselingLiensLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center"} `}
                      >
                        {!opposingCounselingLiensLocks[index].checkID &&
                        opposingCounselingLiensLocks[index].isFinalLocked &&
                        hasNonZeroSettlementAmount(
                          opposingCounselingLiensLocks[index].isFinalAmount
                        ) ? (
                          <div className="d-flex align-items-center justify-content-center">
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                if (opposingCounselingLiensLocks[index].isFinalLocked) {
                                  setCurrentOpposingLien({
                                    ...lien,
                                    final: opposingCounselingLiensLocks[index].isFinalAmount,
                                  });
                                  setCheckRequestModal(true);
                                }
                              }}
                              className="settle-check-request-btn btn"
                              id="nomargin"
                              style={{
                                color: "white",
                                fontWeight: "600",
                                background: "#009900",
                              }}
                            >
                              <p className={"font-weight-semibold"}>Request Check</p>
                            </div>
                          </div>
                        ) : (
                          <SettlementCheckDetails
                            entity={lien}
                            check={opposingCounselingLiensLocks[index].checkID}
                            pageId={page_id_click_record}
                            updateStates={updateOpposingCounselingStates}
                            handleNoCheckShow={handleNoCheckShow}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              {opposingCounselingLiens?.length > 0 && (
                <tr className="cursor-default">
                  <td />
                  <td className="text-end" colSpan={6}>
                    <span className="whitespace-SETTLE primary-clr-25">
                      Total Prior Attorney Liens:{" "}
                    </span>
                    <p
                      className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                      data-value={opposingCounselingLienFinalAmount || 0.0}
                    >
                      {currencyFormat(opposingCounselingLienFinalAmount || 0.0)}
                    </p>
                  </td>
                  <td
                    className="s-draft text-end monospace-font"
                    data-value={opposingCounselingLiensLocksValues[0] || 0.0}
                  >
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={opposingCounselingLiensLocksValues[0] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(opposingCounselingLiensLocksValues[0] || 0.0)}
                    </span>
                  </td>
                  <td
                    className="s-final text-end monospace-font"
                    data-value={opposingCounselingLiensLocksValues[1] || 0.0}
                  >
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={opposingCounselingLiensLocksValues[1] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(opposingCounselingLiensLocksValues[1] || 0.0)}
                    </span>
                  </td>
                  <td className="s-verify" />
                  <td className="td-autosize  text-center" />
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => {
            setShowSettlementPopup(false);
          }}
          _initialLabel={"Attorney Lien"}
          {...settlementObjProps}
        />
      )}
      {showEditLien && (
        <EditAttorneyLiensPopup
          show={showEditLien}
          handleClose={handleEditLienClose}
          attorneyLien={currentOpposingLien}
          updateClientProceedsState={updateClientProceedsState}
          updateOpposingStates={updateOpposingCounselingStates}
        />
      )}
      {showErrorLeinModal && (
        <SettlementErrorModal
          show={showErrorLeinModal}
          handleClose={handleLienErrorClose}
          errorMsg={errorMsg}
          updateStates={updateOpposingCounselingStates}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          finalAmount={currentOpposingLien?.final}
          panelLabel={"OpposingCounselLiens"}
          panelName={"opposing_counsel"}
          panelEntity={currentOpposingLien}
          updateStates={() => {
            updateOpposingCounselingStates();
            updateClientProceedsState();
          }}
        />
      )}
    </>
  );
};

export default OpposingCounselingLiensTable;
